import { Form, StatusChoice } from '@fulcrumapp/fulcrum-core';
import tinycolor from 'tinycolor2';

export interface Colorable {
  getColor: (status: string | undefined) => string;
}

export interface RepeatableWithForm {
  _parent: Form | RepeatableWithForm
}

export const DEFAULT_COLOR = 'red';
export const CYAN_COLOR = '#00FFFF';
export const PARENT_COLOR = '#1798E0';
export const CYAN_RGB_COLOR = [0, 255, 255, 255];

export const applyTransparency = (color: string, alpha: number) => {
  const value = tinycolor(color);
  return alpha !== 0 ? value.setAlpha(alpha).toRgb() : value.toRgb();
};

const isRepeatableElement = (element?: any) => Object.prototype.hasOwnProperty.call(element, '_parent');

const extractParent = (element: RepeatableWithForm) => element._parent;

const extractForm = (form?: Form | RepeatableWithForm): Form | undefined => {
  if (!isRepeatableElement(form)) {
    return form as Form;
  }

  let extracted = extractParent(form as RepeatableWithForm);
  while (isRepeatableElement(extracted)) {
    extracted = (extractParent(extracted as RepeatableWithForm));
  }

  return extracted as Form;
};

const Colorizer = (form?: Form | RepeatableWithForm): Colorable => {
  const useForm = extractForm(form);
  const choices: StatusChoice[] | undefined = useForm?.statusField?.choices;

  const getColor = (status?: string) => {
    if (choices && status) {
      const statusChoice = choices.find((choice: StatusChoice) => (status === choice.value));
      if (statusChoice) {
        return statusChoice.color;
      }
    }
    return DEFAULT_COLOR;
  };

  return {
    getColor,
  };
};

export default Colorizer;
